import { hasProp } from "../../../helpers/Class";
import CarrierDestination from "./CarrierDestination";
import Carrier from "./Carrier";

class CarrierArea {
    constructor(area = null) {
        this.id = !hasProp(area, "id") ? undefined : area.id;
        this.carrierId = !hasProp(area, "carrierId") ? undefined : area.carrierId;
        this.carrier = !hasProp(area, "carrier") ? new Carrier() : new Carrier(area.carrier);
        this.name = !hasProp(area, "name") ? undefined : area.name;

        this.destinations = [];
        if (area !== null && area.destinations) {
            this.destinations = area.destinations.map(destination => new CarrierDestination(destination));
        }
    }
}

export default CarrierArea;